 <template>
  <!-- you can rename class or id for this component, please put your comment what you need for styling needs -->

  <div :class="nameclass || 'passwordDefaultClass'">
    <!-- for each component have default label and classname, 
    you can inherit when you call the component-->
    <label :id="idname || 'labeldefaultpassword'">{{label}}</label>
    <b-form-input
      size="lg"
      v-bind="$attrs"
      type="password"
      v-on="$listeners"
      :value="value"
      @input="$emit('update', $event)"
      @keypress="validatePassword"
      :style="{backgroundColor:value ? 'rgba(79, 208, 110,0.2)':'aliceblue'}"
    ></b-form-input>
    <p
      class="validation-message"
      v-if="isValid == false||nameclass['error register-input']==true"
    >{{msg||'Password length must be at least 8 characters'}}</p>
    <p
      class="validation-message"
      v-if="msg"
    >{{msg||'Password length must be at least 8 characters'}}</p>
  </div>
</template>

  <script>
export default {
  data: () => {
    return {
      isValid: null,
    };
  },
  inheritAttrs: false,
  props: ["value", "label", "nameclass", "idname", "isPasswordValid",'msg'],
  model: {
    prop: "value",
    event: "update"
  },
  methods: {
    validatePassword() {
      var reg = /^\d+$/;
      if (this.value.length >= 7) {
        this.isValid = true;
        this.$emit("validatePassword", true);
      } else if (this.value == "") {
        this.isValid = null;
        this.$emit("validatePassword", false);
      }else if (this.value == "") {
        this.isValid = null;
        this.$emit("validatePassword", false);
      }else {
        this.isValid = false;
        this.$emit("validatePassword", false);
      }
    }
  },
  watch: {
    value: function(updated, old) {
      if (updated == "") {
        this.isValid = null;
      }
    }
  }
};
</script>